import { Button, Group, Stack, Text, Title } from '@grovus/design-system'
import type { Intent } from '../auth/entry'
import type { Reconciled } from '../auth/reconcile'
import { AUTH_COPY, MEMBERS_COPY, type Lang } from '../i18n'
import { InvitationList } from './InvitationList'
import type { Invitations } from './useInvitations'

interface Props {
  lang: Lang
  invitations: Invitations
  onReconcile: (intent?: Intent) => Promise<Reconciled>
}

/**
 * The shell screen `invitations` (GRO-106 design, screen 3). An Accept here keeps the
 * active company: the boundary adds the joined notice, which App shows above the screen
 * with "Switch to <client>".
 */
export function InvitationsPage({ lang, invitations, onReconcile }: Props) {
  const copy = MEMBERS_COPY[lang]
  const { state } = invitations
  return (
    <Stack gap={24} p={{ base: 16, sm: 24 }} maw={720} data-testid="invitations-page">
      <Title order={2} fz="xl">{copy.invitations}</Title>
      {state.phase === 'loading' && <Text className="grv-muted" role="status">{copy.invitationsLoading}</Text>}
      {state.phase === 'failed' && (
        <Group gap="xs" role="alert">
          <Text className="grv-muted">{AUTH_COPY[lang].service_unavailable}</Text>
          <Button size="compact-sm" variant="default" onClick={() => { void invitations.refetch() }}>{copy.retry}</Button>
        </Group>
      )}
      {state.phase === 'ready' && state.items.length === 0 && <Text className="grv-muted">{copy.ledeNone}</Text>}
      <InvitationList
        lang={lang}
        items={state.phase === 'ready' ? state.items : []}
        origin="shell"
        onReconcile={onReconcile}
        invitations={invitations}
      />
    </Stack>
  )
}
